import { useState } from "react";
const useEditorAi = () => {
    const [activeItem, setActiveItem] = useState(null);
    return {
        activeItem,
        setActiveItem,
    };
};
export default useEditorAi;
//# sourceMappingURL=useEditorAi.js.map